import { Icon } from '../primitives';
import { useTranslation } from 'react-i18next';

/**
 * CreateAiPill — glass-gradient pill для выбора типа генерации в CreatePopup.
 *
 * Figma source: `318:3435` (AI фото) / `318:3476` (AI видео) внутри row
 * `318:3523` (Frame 31) в overlay `318:3434`.
 *
 * Geometry (FIXED per Figma, figma-spec §1+§2):
 *   - size    : 160×88
 *   - layout  : VERTICAL, counterAxisAlignItems=CENTER
 *   - padding : [16, 24, 16, 24]
 *   - itemSpacing: 8
 *   - radius  : 24 (home-24)
 *
 * Fill (figma-spec §1 colors):
 *   - linear-gradient 180°: ai-pill-start (rgba(255,255,255,0.08))
 *                        →  ai-pill-end   (rgba(255,255,255,0.32))
 *
 * Stroke (figma-spec §1): linear gray α0→α0.48 1px inside — приближаем
 * одноцветным border-white/α (glass-stroke); figma-reviewer проверит parity
 * через figma_check_design_parity в финальной стадии.
 *
 * Effect: backdropBlur 64px (backdrop-blur-ai-pill token).
 *
 * Icon: 32×32, name='image' (70:2628) для photo, name='video' (70:2629)
 * для video — оба уже экспортированы в /public/icons/.
 *
 * Label: Raleway Bold 14/16.436 белый, text-ai-pill token.
 */
const LABEL_KEYS = { photo: 'create.photo', video: 'create.video' };
const LABEL_FALLBACKS = { photo: 'AI фото', video: 'AI видео' };
const ICONS = { photo: 'image', video: 'video' };

export default function CreateAiPill({ variant, onClick }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      className={[
        'flex flex-col items-center justify-center gap-2',
        'w-[160px] h-[88px] px-6 py-4',
        'rounded-home-24',
        'bg-gradient-to-b from-ai-pill-start to-ai-pill-end',
        'border border-glass-stroke-end',
        'backdrop-blur-ai-pill',
        'text-base-white',
      ].join(' ')}
    >
      <Icon name={ICONS[variant]} size={32} />
      <span className="text-ai-pill">{t(LABEL_KEYS[variant], LABEL_FALLBACKS[variant])}</span>
    </button>
  );
}
